/**
 * Akiso PDP — gallery, dual size selection, sticky bar, ATC.
 * Expects #akiso-pdp root with data attributes + JSON variants.
 */

/* Drop stale ?view=akiso-pdp only when product already uses that template. */
(function stripStaleAkisoView() {
  try {
    var url = new URL(window.location.href);
    if (url.searchParams.get('view') !== 'akiso-pdp') return;
    var root = document.getElementById('akiso-pdp');
    var suffix = root && root.getAttribute('data-template-suffix');
    if (suffix === 'akiso-pdp') {
      url.searchParams.delete('view');
      window.location.replace(url.pathname + url.search + url.hash);
    }
  } catch (e) {}
})();

(function () {
  const root = document.getElementById('akiso-pdp');
  if (!root) return;

  const variants = JSON.parse(root.querySelector('[data-ak-variants]').textContent);
  const moneyFormat = root.dataset.moneyFormat || '{{amount}}';
  const sectionId = root.dataset.sectionId;
  const sizeMode = (root.dataset.sizeMode || 'dual').toLowerCase(); // dual | single

  const state = {
    active: 0,
    top: null,
    pant: null,
    qty: 1,
    country: root.dataset.country || 'in',
    adding: false,
  };

  const els = {
    stageImgs: root.querySelectorAll('[data-ak-stage-img]'),
    thumbs: root.querySelectorAll('[data-ak-thumb]'),
    counter: root.querySelector('[data-ak-counter]'),
    topChips: root.querySelectorAll('[data-ak-top]'),
    pantChips: root.querySelectorAll('[data-ak-pant]'),
    errTop: root.querySelector('[data-ak-err-top]'),
    errPant: root.querySelector('[data-ak-err-pant]'),
    errSize: root.querySelector('[data-ak-err-size]'),
    sizeChips: root.querySelectorAll('[data-ak-size]'),
    qtyVal: root.querySelector('[data-ak-qty]') || { textContent: '1' },
    idInput: root.querySelector('[data-ak-id]'),
    priceNow: root.querySelector('[data-ak-price-now]'),
    priceWas: root.querySelector('[data-ak-price-was]'),
    priceSave: root.querySelector('[data-ak-price-save]'),
    saveLabel: root.dataset.saveLabel || '',
    addBtns: document.querySelectorAll('[data-ak-add]'),
    buyNow: root.querySelector('[data-ak-buynow]'),
    sticky: document.querySelector('[data-ak-sticky]'),
    stickyImg: document.querySelector('[data-ak-sticky-img]'),
    stickyPrice: document.querySelector('[data-ak-sticky-price]'),
    buyBox: root.querySelector('[data-ak-buybox]'),
    cta: root.querySelector('[data-ak-cta]'),
    light: root.querySelector('[data-ak-light]'),
    lightImg: root.querySelector('[data-ak-light-img]'),
    lightCount: root.querySelector('[data-ak-light-count]'),
    flySrc: root.querySelector('[data-ak-fly-src]'),
    countryInput: root.querySelector('[name="mlveda_country"]'),
  };

  function stripHtml(value) {
    return String(value || '')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .trim();
  }

  function formatMoney(cents) {
    const value = Number(cents) || 0;
    const activeCurrency =
      (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) ||
      '';

    try {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        // Shopify money formats often include <span class=money>…</span>;
        // we always set prices via textContent, so strip tags.
        return stripHtml(Shopify.formatMoney(value, moneyFormat));
      }
    } catch (e) {}

    // Respect shop / presentment currency — never force INR on global (USD) stores.
    const currency =
      activeCurrency ||
      (moneyFormat.includes('₹') || /Rs\.?/i.test(moneyFormat)
        ? 'INR'
        : moneyFormat.includes('$')
          ? 'USD'
          : 'USD');
    try {
      return (value / 100).toLocaleString(currency === 'INR' ? 'en-IN' : 'en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch (e) {
      const amount = (value / 100).toFixed(2);
      if (currency === 'INR') return '₹' + amount;
      return '$' + amount;
    }
  }

  function findVariant() {
    // Single-option products: Size + optional mlveda_country (option2)
    if (sizeMode === 'single') {
      if (!state.top) return null;
      return (
        variants.find(
          (v) =>
            v.option1 === state.top &&
            (v.option2 === state.country || !v.option2 || v.option2 === state.top)
        ) ||
        variants.find((v) => v.option1 === state.top && v.option2 === state.country) ||
        variants.find((v) => v.option1 === state.top) ||
        null
      );
    }

    // Dual: Top Size + Pant Size (+ country as option3)
    if (!state.top || !state.pant) return null;
    return (
      variants.find(
        (v) =>
          v.option1 === state.top &&
          v.option2 === state.pant &&
          (v.option3 === state.country || !v.option3)
      ) ||
      variants.find((v) => v.option1 === state.top && v.option2 === state.pant) ||
      null
    );
  }

  function displayVariant() {
    // Prefer selected size combo; before size pick, fall back so sale badge still shows
    const selected = findVariant();
    if (selected) return selected;
    if (sizeMode === 'single') {
      return (
        variants.find((v) => v.option2 === state.country && v.available !== false) ||
        variants.find((v) => v.option2 === state.country) ||
        variants.find((v) => !v.option2 || v.option2 === state.country) ||
        variants[0] ||
        null
      );
    }
    const byCountry =
      variants.find((v) => v.option3 === state.country && v.available !== false) ||
      variants.find((v) => !v.option3 || v.option3 === state.country);
    return byCountry || variants[0] || null;
  }

  function syncVariant() {
    const selected = findVariant();
    const v = displayVariant();
    if (els.idInput) els.idInput.value = selected ? selected.id : (v ? v.id : '');
    if (v && els.priceNow) els.priceNow.textContent = formatMoney(v.price);
    if (v && els.stickyPrice) els.stickyPrice.textContent = formatMoney(v.price);

    const compareAt = v ? Number(v.compare_at_price || 0) : 0;
    const price = v ? Number(v.price || 0) : 0;
    const onSale = !!(v && compareAt > price);

    if (els.priceWas) {
      if (onSale) {
        els.priceWas.textContent = formatMoney(compareAt);
        els.priceWas.hidden = false;
      } else {
        els.priceWas.textContent = '';
        els.priceWas.hidden = true;
      }
    }
    if (els.priceSave) {
      if (onSale) {
        const pct = Math.round(((compareAt - price) / compareAt) * 100);
        els.priceSave.textContent = 'Save ' + pct + '%';
        els.priceSave.hidden = false;
      } else {
        els.priceSave.textContent = '';
        els.priceSave.hidden = true;
      }
    }
    root.dispatchEvent(new CustomEvent('akiso:variant', { detail: { variant: selected || v } }));
  }

  function setActive(i) {
    const n = els.stageImgs.length;
    if (!n) return;
    state.active = ((i % n) + n) % n;
    els.stageImgs.forEach((img, idx) => img.classList.toggle('is-active', idx === state.active));
    els.thumbs.forEach((btn, idx) => btn.classList.toggle('is-active', idx === state.active));
    if (els.counter) {
      const cur = String(state.active + 1).padStart(2, '0');
      const tot = String(n).padStart(2, '0');
      els.counter.innerHTML = cur + ' <i>/</i> ' + tot;
    }
    const activeThumb = els.thumbs[state.active];
    if (activeThumb && activeThumb.parentElement) {
      const rail = activeThumb.parentElement;
      const horizontal = rail.scrollWidth > rail.clientWidth;
      if (horizontal) {
        const left = activeThumb.offsetLeft - rail.clientWidth / 2 + activeThumb.clientWidth / 2;
        rail.scrollTo({ left, behavior: 'smooth' });
      } else {
        const top = activeThumb.offsetTop - rail.clientHeight / 2 + activeThumb.clientHeight / 2;
        rail.scrollTo({ top, behavior: 'smooth' });
      }
    }
    if (els.stickyImg && els.stageImgs[state.active]) {
      els.stickyImg.src = els.stageImgs[state.active].dataset.thumb || els.stageImgs[state.active].src;
    }
  }

  function setSize(kind, value) {
    state[kind] = value;
    const chips = kind === 'top' ? els.topChips : els.pantChips;
    const err = kind === 'top' ? els.errTop : els.errPant;
    chips.forEach((c) =>
      c.classList.toggle(
        'is-active',
        c.getAttribute(kind === 'top' ? 'data-ak-top' : 'data-ak-pant') === value
      )
    );
    if (err) err.hidden = true;
    if (els.errSize) els.errSize.hidden = true;
    refreshDualAvailability();
    syncVariant();
  }

  function setUnifiedSize(value) {
    state.top = value;
    state.pant = value;
    els.sizeChips.forEach((c) => c.classList.toggle('is-active', c.getAttribute('data-ak-size') === value));
    els.topChips.forEach((c) => c.classList.toggle('is-active', c.getAttribute('data-ak-top') === value));
    els.pantChips.forEach((c) => c.classList.toggle('is-active', c.getAttribute('data-ak-pant') === value));
    if (els.errTop) els.errTop.hidden = true;
    if (els.errPant) els.errPant.hidden = true;
    if (els.errSize) els.errSize.hidden = true;
    syncVariant();
  }

  function variantMatchesCountry(v) {
    return !v.option3 || v.option3 === state.country;
  }

  function refreshDualAvailability() {
    if (sizeMode !== 'dual') return;
    els.topChips.forEach((chip) => {
      const value = chip.getAttribute('data-ak-top');
      const ok = variants.some((v) => {
        if (v.option1 !== value || !variantMatchesCountry(v) || v.available === false) return false;
        if (state.pant && v.option2 !== state.pant) return false;
        return true;
      });
      chip.classList.toggle('is-out', !ok);
      chip.disabled = !ok;
      if (!ok) chip.setAttribute('title', 'Sold out');
      else chip.removeAttribute('title');
    });
    els.pantChips.forEach((chip) => {
      const value = chip.getAttribute('data-ak-pant');
      const ok = variants.some((v) => {
        if (v.option2 !== value || !variantMatchesCountry(v) || v.available === false) return false;
        if (state.top && v.option1 !== state.top) return false;
        return true;
      });
      chip.classList.toggle('is-out', !ok);
      chip.disabled = !ok;
      if (!ok) chip.setAttribute('title', 'Sold out');
      else chip.removeAttribute('title');
    });
  }

  // Gallery
  els.thumbs.forEach((btn, i) => btn.addEventListener('click', () => setActive(i)));
  root.querySelectorAll('[data-ak-prev]').forEach((b) =>
    b.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setActive(state.active - 1);
    })
  );
  root.querySelectorAll('[data-ak-next]').forEach((b) =>
    b.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setActive(state.active + 1);
    })
  );

  // Zoom / lightbox + mobile horizontal gallery
  const stage = root.querySelector('[data-ak-stage]');
  const stageWrap = root.querySelector('.ak-stage-wrap') || stage;
  if (stage) {
    const canHoverZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const isOverArrow = (el) => !!(el && el.closest && el.closest('[data-ak-prev], [data-ak-next]'));
    const setZoom = (on) => stage.classList.toggle('is-zoom', !!on);
    if (canHoverZoom) {
      stage.addEventListener('mouseenter', (e) => {
        if (!isOverArrow(e.target)) setZoom(true);
      });
      stage.addEventListener('mouseleave', () => setZoom(false));
      stage.addEventListener('mousemove', (e) => {
        if (isOverArrow(e.target)) {
          setZoom(false);
          return;
        }
        setZoom(true);
        const r = stage.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width) * 100;
        const y = ((e.clientY - r.top) / r.height) * 100;
        const img = els.stageImgs[state.active];
        if (img) img.style.transformOrigin = x + '% ' + y + '%';
      });
      root.querySelectorAll('[data-ak-prev], [data-ak-next]').forEach((btn) => {
        btn.addEventListener('mouseenter', (e) => {
          e.stopPropagation();
          setZoom(false);
        });
        btn.addEventListener('mouseleave', (e) => {
          if (stage.contains(e.relatedTarget) && !isOverArrow(e.relatedTarget)) {
            setZoom(true);
          }
        });
      });
    }

    // Axis-locked swipe: horizontal changes image; vertical lets the page scroll
    // (critical on mobile — overflow-x scrollports trap vertical scroll on iOS).
    const swipe = { x: 0, y: 0, active: false, moved: false, axis: '' };
    const SWIPE_MIN = 40;
    stage.addEventListener(
      'touchstart',
      (e) => {
        if (!e.touches || !e.touches[0]) return;
        if (isOverArrow(e.target)) return;
        swipe.active = true;
        swipe.moved = false;
        swipe.axis = '';
        swipe.x = e.touches[0].clientX;
        swipe.y = e.touches[0].clientY;
        stage.classList.add('is-swiping');
      },
      { passive: true }
    );
    stage.addEventListener(
      'touchmove',
      (e) => {
        if (!swipe.active || !e.touches || !e.touches[0]) return;
        const dx = e.touches[0].clientX - swipe.x;
        const dy = e.touches[0].clientY - swipe.y;
        if (!swipe.axis) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          swipe.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (swipe.axis === 'x') {
          swipe.moved = true;
          // Claim the gesture so the page doesn't also scroll sideways
          e.preventDefault();
        }
        // axis === 'y': do nothing — browser scrolls the page (touch-action: pan-y)
      },
      { passive: false }
    );
    stage.addEventListener(
      'touchend',
      (e) => {
        if (!swipe.active) return;
        const t = e.changedTouches && e.changedTouches[0];
        const dx = t ? t.clientX - swipe.x : 0;
        const dy = t ? t.clientY - swipe.y : 0;
        const axis = swipe.axis;
        stage.classList.remove('is-swiping');
        swipe.active = false;
        swipe.axis = '';
        if (axis === 'x' && Math.abs(dx) >= SWIPE_MIN && Math.abs(dx) > Math.abs(dy)) {
          setActive(state.active + (dx < 0 ? 1 : -1));
          swipe.moved = true;
        }
      },
      { passive: true }
    );
    stage.addEventListener('touchcancel', () => {
      swipe.active = false;
      swipe.moved = false;
      swipe.axis = '';
      stage.classList.remove('is-swiping');
    });

    stage.addEventListener('click', (e) => {
      if (e.target.closest('[data-ak-prev], [data-ak-next]')) return;
      if (swipe.moved) {
        swipe.moved = false;
        return;
      }
      if (!canHoverZoom) return;
      openLight(true);
    });
  }
  root.querySelectorAll('[data-ak-zoom]').forEach((b) =>
    b.addEventListener('click', (e) => {
      e.stopPropagation();
      openLight(true);
    })
  );

  function openLight(open) {
    if (!els.light) return;
    els.light.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (open && els.lightImg) {
      els.lightImg.src = els.stageImgs[state.active].src;
      if (els.lightCount) els.lightCount.textContent = state.active + 1 + ' / ' + els.stageImgs.length;
    }
  }
  if (els.light) {
    els.light.addEventListener('click', () => openLight(false));
    els.light.querySelectorAll('[data-ak-light-close]').forEach((b) => b.addEventListener('click', () => openLight(false)));
    els.light.querySelectorAll('[data-ak-light-prev]').forEach((b) =>
      b.addEventListener('click', (e) => {
        e.stopPropagation();
        setActive(state.active - 1);
        openLight(true);
      })
    );
    els.light.querySelectorAll('[data-ak-light-next]').forEach((b) =>
      b.addEventListener('click', (e) => {
        e.stopPropagation();
        setActive(state.active + 1);
        openLight(true);
      })
    );
  }
  document.addEventListener('keydown', (e) => {
    if (els.light && !els.light.hidden) {
      if (e.key === 'Escape') openLight(false);
      if (e.key === 'ArrowLeft') {
        setActive(state.active - 1);
        openLight(true);
      }
      if (e.key === 'ArrowRight') {
        setActive(state.active + 1);
        openLight(true);
      }
    }
  });

  // Sizes — unified Size row (sets Top + Pant together) or separate dual rows
  if (els.sizeChips && els.sizeChips.length) {
    els.sizeChips.forEach((c) =>
      c.addEventListener('click', () => setUnifiedSize(c.getAttribute('data-ak-size')))
    );
  } else {
    els.topChips.forEach((c) => c.addEventListener('click', () => setSize('top', c.getAttribute('data-ak-top'))));
    els.pantChips.forEach((c) => c.addEventListener('click', () => setSize('pant', c.getAttribute('data-ak-pant'))));
    refreshDualAvailability();
  }

  // Qty
  root.querySelectorAll('[data-ak-qty-dec]').forEach((b) =>
    b.addEventListener('click', () => {
      state.qty = Math.max(1, state.qty - 1);
      if (els.qtyVal) els.qtyVal.textContent = state.qty;
    })
  );
  root.querySelectorAll('[data-ak-qty-inc]').forEach((b) =>
    b.addEventListener('click', () => {
      state.qty += 1;
      if (els.qtyVal) els.qtyVal.textContent = state.qty;
    })
  );

  // Country (mlveda)
  function detectCountry() {
    const testIntl = window.location.search.includes('test_intl');
    let isIN = true;
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      isIN = /Kolkat|Calcutt|Asia\/Kolkata/i.test(tz) || (navigator.language || '').toLowerCase().includes('-in');
    } catch (e) {}
    if (typeof window.isUserInIndia === 'function') {
      try {
        isIN = window.isUserInIndia();
      } catch (e) {}
    }
    state.country = testIntl || !isIN ? 'intl' : 'in';
    if (els.countryInput) els.countryInput.value = state.country;
    refreshDualAvailability();
    syncVariant();
  }
  detectCountry();

  // Accordions
  root.querySelectorAll('[data-ak-acc]').forEach((acc) => {
    const head = acc.querySelector('[data-ak-acc-head]');
    const wrap = acc.querySelector('[data-ak-acc-wrap]');
    const body = acc.querySelector('[data-ak-acc-body]');
    head.addEventListener('click', () => {
      const open = acc.classList.toggle('is-open');
      if (!wrap || !body) return;
      if (open) {
        wrap.style.height = body.scrollHeight + 'px';
        setTimeout(() => {
          if (acc.classList.contains('is-open')) wrap.style.height = 'auto';
        }, 340);
      } else {
        wrap.style.height = body.scrollHeight + 'px';
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            wrap.style.height = '0px';
          })
        );
      }
    });
  });

  // Reveal
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );
  root.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  // Sticky bar: hide only while main ATC / Buy now row is on screen
  // Hysteresis via rootMargin asymmetry to stop threshold flicker
  if (els.sticky) {
    const ctaTarget = els.cta || els.buyBox;
    if (ctaTarget) {
      let stickyShown = false;
      const sio = new IntersectionObserver(
        ([e]) => {
          const shouldShow = !e.isIntersecting;
          if (shouldShow === stickyShown) return;
          stickyShown = shouldShow;
          els.sticky.classList.toggle('is-show', shouldShow);
        },
        { threshold: [0, 0.01], rootMargin: '12px 0px -24px 0px' }
      );
      sio.observe(ctaTarget);
    } else {
      els.sticky.classList.add('is-show');
    }
  }

  function flyToCart() {
    const src = els.flySrc || els.stageImgs[state.active];
    const cart =
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('[data-ak-cart-target]');
    if (!src || !cart) return;
    const s = src.getBoundingClientRect();
    const c = cart.getBoundingClientRect();
    const ghost = document.createElement('img');
    ghost.src = src.currentSrc || src.src;
    ghost.className = 'ak-fly';
    Object.assign(ghost.style, {
      position: 'fixed',
      zIndex: 80,
      objectFit: 'cover',
      pointerEvents: 'none',
      left: s.left + 'px',
      top: s.top + 'px',
      width: s.width + 'px',
      height: s.height + 'px',
      transition: 'all .8s cubic-bezier(0.65, 0, 0.35, 1)',
      borderRadius: '4px',
    });
    document.body.appendChild(ghost);
    requestAnimationFrame(() => {
      Object.assign(ghost.style, {
        left: c.left + c.width / 2 - 24 + 'px',
        top: c.top + c.height / 2 - 24 + 'px',
        width: '48px',
        height: '48px',
        opacity: '0.2',
        transform: 'rotate(8deg)',
      });
    });
    setTimeout(() => ghost.remove(), 850);
  }

  async function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    // Refresh cart drawer sections if present
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const data = await res.json();
      if (data['cart-drawer'] && drawer) {
        drawer.innerHTML = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('cart-drawer').innerHTML;
        if (typeof drawer.open === 'function') drawer.open();
      }
    } catch (e) {}
  }

  function showToast(message) {
    const existing = document.querySelector('.ak-toast');
    if (existing) existing.remove();
    const el = document.createElement('div');
    el.className = 'ak-toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(() => el.classList.add('is-in'));
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => {
      el.classList.remove('is-in');
      el.classList.add('is-out');
      setTimeout(() => el.remove(), 280);
    }, 2800);
  }

  async function addToCart(goCheckout) {
    if (state.adding) return;
    const needsSize =
      sizeMode === 'single' ? !state.top : !state.top || !state.pant;
    if (needsSize) {
      if (els.errTop && !state.top) els.errTop.hidden = false;
      if (els.errPant && sizeMode !== 'single' && !state.pant) els.errPant.hidden = false;
      if (els.errSize) els.errSize.hidden = false;
      showToast(sizeMode === 'single' ? 'Please select the size' : 'Please select top and pant size');
      const box = root.querySelector('.ph-sizes') || root.querySelector('.ak-sizes');
      if (box)
        box.animate(
          [{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }],
          { duration: 320 }
        );
      return;
    }
    const v = findVariant();
    if (!v) {
      alert('This size combination is unavailable.');
      return;
    }
    state.adding = true;
    els.addBtns.forEach((b) => b.classList.add('is-loading'));
    flyToCart();
    try {
      const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: state.qty }] }),
      });
      if (!res.ok) throw new Error('Add failed');
      if (goCheckout) {
        window.location.href = '/checkout';
        return;
      }
      els.addBtns.forEach((b) => {
        b.classList.remove('is-loading');
        b.classList.add('is-done');
        const label = b.querySelector('.ak-add__label');
        if (label) label.textContent = 'Added';
      });
      setTimeout(() => {
        els.addBtns.forEach((b) => {
          b.classList.remove('is-done');
          const label = b.querySelector('.ak-add__label');
          if (label) label.textContent = 'Add to cart';
        });
      }, 2000);
      // Publish for theme cart
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (typeof publish === 'function') {
        try {
          publish('cart-update');
        } catch (e) {}
      }
      await openCartDrawer();
      // Fallback: fetch cart drawer HTML update via product-form pattern
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents !== 'function') {
        fetch('/cart.js')
          .then((r) => r.json())
          .then(() => {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) bubble.classList.remove('is-empty');
          });
      }
      // Dawn-style section refresh
      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then((r) => r.json())
        .then((sections) => {
          if (sections['cart-icon-bubble']) {
            const el = document.getElementById('cart-icon-bubble');
            if (el) el.innerHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section')?.innerHTML || sections['cart-icon-bubble'];
          }
          if (sections['cart-drawer'] && cartDrawer) {
            const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            const next = parsed.querySelector('cart-drawer');
            if (next) {
              cartDrawer.innerHTML = next.innerHTML;
              cartDrawer.classList.remove('is-empty');
              if (typeof cartDrawer.open === 'function') cartDrawer.open();
            }
          }
        })
        .catch(() => {});
    } catch (err) {
      console.error(err);
      alert('Could not add to cart. Please try again.');
    } finally {
      state.adding = false;
      els.addBtns.forEach((b) => b.classList.remove('is-loading'));
    }
  }

  els.addBtns.forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    addToCart(false);
  }));
  if (els.buyNow) {
    els.buyNow.addEventListener('click', (e) => {
      e.preventDefault();
      addToCart(true);
    });
  }

  // Coupon copy (design-system ap-phero__couponcopy)
  root.querySelectorAll('[data-ak-copy-code]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const code = btn.getAttribute('data-ak-copy-code') || '';
      if (!code) return;
      const done = () => {
        const prev = btn.textContent;
        btn.textContent = 'Copied';
        btn.classList.add('is-copied');
        setTimeout(() => {
          btn.textContent = prev || 'Copy code';
          btn.classList.remove('is-copied');
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(() => {
          try {
            const ta = document.createElement('textarea');
            ta.value = code;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
          } catch (e) {}
          done();
        });
      } else {
        done();
      }
    });
  });

  setActive(0);
  syncVariant();
})();
